module.exports = __webpack_public_path__ + "static/page-transition-c5521584394ff5ccbf5f68bc3c51c49f.gif";